import React from "react";
import Homepage from "./components/screens/Homepage";
import SignIn from "./components/screens/SignIn";
import { BrowserRouter, Switch, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Homepage} />
        <Route exact path="/signin" component={SignIn} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
